import { Row, Col } from 'react-bootstrap'

const About = () => {
    return (
        <Row className="about mx-0" id="about">
            <Row className="mx-0">
                <div className="sectionTitle reveal">
                    About Linko Labs
                </div>
            </Row>
            <Row className="aboutContent mx-0 justify-content-center">
                <Col className="col-12 col-lg-8">
                    <div className="aboutCard reveal">
                        <p className="aboutText">
                            <strong>Linko Labs LLC</strong> is a software development and AI integration company 
                            registered in New York, USA. We provide custom development services to 
                            international clients under contract-based agreements.
                        </p>
                        <p className="aboutText">
                            Our team specializes in building practical, scalable solutions that help 
                            businesses automate operations, integrate intelligent systems, and develop 
                            custom applications tailored to their specific needs.
                        </p>
                        <p className="aboutText">
                            We work with clients across time zones and industries, delivering projects 
                            through a structured process with clear milestones and transparent communication.
                        </p>
                        <div className="aboutDetails">
                            <div className="aboutDetailItem">
                                <span className="aboutDetailLabel">Location:</span>
                                <span className="aboutDetailValue">New York, USA</span>
                            </div>
                            <div className="aboutDetailItem">
                                <span className="aboutDetailLabel">Founded:</span>
                                <span className="aboutDetailValue">2022</span>
                            </div>
                            <div className="aboutDetailItem">
                                <span className="aboutDetailLabel">Focus:</span>
                                <span className="aboutDetailValue">Custom Software & AI Integration</span>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </Row>
    )
}

export default About
